<p-button [text]="text" [disabled]="disabled" [label]="label"  [type]="type" [icon]="icon" [styleClass]="marginAndPadding ? 'p-button-rounded m-2 p-2' : 'p-button-rounded p-2 w-full'"></p-button>
